export enum IntegrationLogoType {
  Github = "Github",
  Jira = "Jira",
  Salesforce = "Salesforce",
  Clickup = "Clickup",
  Hubspot = "Hubspot",
  Linear = "Linear",
  YouTrack = "YouTrack",
  Topicflow = "Topicflow",
  Merge = "Merge",
}

// Convert provider string to IntegrationLogoType
export const getIntegrationLogoTypeFromProvider = (
  provider: string,
): IntegrationLogoType => {
  if (!provider) {
    return IntegrationLogoType.Topicflow;
  }
  const lowerProvider = provider.toLowerCase();

  if (lowerProvider.startsWith("merge_")) {
    return IntegrationLogoType.Merge;
  }

  // Native integrations
  switch (lowerProvider) {
    case "github":
      return IntegrationLogoType.Github;
    case "jira":
      return IntegrationLogoType.Jira;
    case "salesforce":
      return IntegrationLogoType.Salesforce;
    case "clickup":
      return IntegrationLogoType.Clickup;
    case "hubspot":
      return IntegrationLogoType.Hubspot;
    case "linear":
      return IntegrationLogoType.Linear;
    case "youtrack":
      return IntegrationLogoType.YouTrack;
    case "topicflow":
      return IntegrationLogoType.Topicflow;
    default:
      return IntegrationLogoType.Topicflow;
  }
};

// Convert __typename to provider string
export const getProviderFromNodeType = (node: {
  __typename: string;
}): string => {
  if (node.__typename === "GithubIssueNode") {
    return "github";
  } else if (node.__typename === "JiraIssueNode") {
    return "jira";
  } else if (node.__typename === "SalesforceOpportunityNode") {
    return "salesforce";
  } else if (node.__typename === "ClickupTaskNode") {
    return "clickup";
  } else if (node.__typename === "HubspotDealNode") {
    return "hubspot";
  } else if (
    node.__typename === "LinearIssueNode" ||
    node.__typename === "LinearProjectNode"
  ) {
    return "linear";
  } else if (
    node.__typename === "YoutrackIssueNode" ||
    node.__typename === "YouTrackIssueNode" ||
    node.__typename === "YouTrackProjectNode"
  ) {
    return "youtrack";
  } else if (node.__typename === "TopicflowArtifactNode") {
    return "topicflow";
  }
  return "topicflow";
};
